import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbButton as ClbButton_ } from '@celebration/design-system/dist/lib/button';
const events = {
    onClbClick: ClbButton_.events.onClbClick,
};
export const ClbButton = createComponent({
    tagName: ClbButton_.tagName,
    elementClass: ClbButton_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map